import React from 'react';
import { Link } from 'react-router-dom';

export const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t bg-white py-6 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-500">
            © {year} FAD - Fate After Dice. All rights reserved.
          </p>
          <nav className="flex items-center gap-6 text-sm text-gray-500">
            <Link to="/about" className="hover:text-gray-700">
              About
            </Link>
            <a
              href="https://github.com/jnickg/fad"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-gray-700"
            >
              GitHub
            </a>
          </nav>
        </div>
      </div>
    </footer>
  );
};
